import { render, staticRenderFns } from "./authConfig.vue?vue&type=template&id=7231faae&scoped=true&"
import script from "./authConfig.vue?vue&type=script&lang=ts&"
export * from "./authConfig.vue?vue&type=script&lang=ts&"
import style0 from "./authConfig.vue?vue&type=style&index=0&id=7231faae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7231faae",
  null
  
)

export default component.exports